import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbDownCurved: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThumbDownCurved"><Path d="M11.6315 22.0864L11.9244 21.3854C13.0017 17.5 16.0017 15.445 16.0017 12.7301V6.27476C16.0017 5.12833 15.3381 3.9995 14.1661 3.57273C11.5152 2.60744 9.76815 2.41102 7.04211 2.64726C4.95127 2.82846 3.37955 4.43151 2.94397 6.36742L2.09922 10.1219C1.53654 12.6227 3.43833 14.9999 6.00166 14.9999L9.00166 15C8.50166 18 7.23374 21.5367 11.6315 22.0864Z" fill="currentColor"/><Path d="M22.0017 14.5H17.0017V3.49997H22.0017V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbDownCurved;
